import {
  IconCheck,
  IconChecks,
  IconClock,
} from '@tabler/icons-react';

/**
 * ЗНАЧОК ДОСТАВКИ — ОДНО МЕСТО НА ВСЮ ПЕРЕПИСКУ (`s608`, 18.09.2026).
 *
 * ⛔⛔ ЭКРАН НЕ РЕШАЕТ, ЧТО ЗНАЧИТ СТАТУС. Сервер присылает готовый ВИД
 * доставки, потому что один и тот же код значит разное на разных каналах: у
 * Telegram «мессенджер принял» — это КОНЕЦ лестницы (событий доставки Bot API
 * не шлёт вовсе), у официального WhatsApp — её середина. Знает разницу
 * провайдер, и считает её сервер (закон `s104`).
 *
 * ⛔ ОДИН КОМПОНЕНТ НА СПИСОК И НА ЛЕНТУ. До этого значок рисовался в двух
 * местах своими руками, и они уже разошлись: в списке две галочки стояли по
 * ЛЮБОМУ непустому статусу, в ленте — по одному из четырёх. Дефект вида
 * чинится правилом на общей трубе (op-rules §33.2), а не подгонкой одного
 * места под другое.
 *
 * Ступени как в мессенджере, с которым владелец сравнивает:
 *   ждём подтверждения  → часы
 *   мессенджер принял   → одна галочка (и будет продолжение)
 *   доехало до человека → две серые
 *   прочитано           → две цветные
 *   не ушло             → словами, красным (значка нет: это не ступень)
 */
export type VidDostavki =
  | 'zhdyom'
  | 'ushlo'
  | 'dostavleno'
  | 'prochitano'
  | 'ne_ushlo';

interface Props {
  vid: string | null;
  razmer?: number;
}

export function ZnachokDostavki({ vid, razmer = 13 }: Props) {
  if (vid === 'zhdyom') {
    return <IconClock size={razmer} className="shrink-0 text-ops-text-tertiary" />;
  }

  if (vid === 'ushlo') {
    return <IconCheck size={razmer} className="shrink-0 text-ops-text-tertiary" />;
  }

  if (vid === 'dostavleno') {
    return <IconChecks size={razmer} className="shrink-0 text-ops-text-tertiary" />;
  }

  if (vid === 'prochitano') {
    return <IconChecks size={razmer} className="shrink-0 text-ops-primary" />;
  }

  // `ne_ushlo` рисует словами тот, кто знает словарь экрана; прочее — ничего.
  return null;
}
